import { useContext, useEffect, useState, useRef } from 'react'
import css from "./alexa.module.scss";
import { Layout } from "../../../componentsV1/layout";
import Logo from "../../../assets/v1/logo.png";
import { Validation } from "../../../assets/v1/icons";
import Graph from './graph'
import Dropdown from "../../../components/Dropdown"
import { toAbsoluteUrl } from '../../../utils/assetHelper'
import { useNavigate } from 'react-router-dom'
import MethodologyModal from "../../../componentsV1/modals/MethodologyModal"
import { getProductApi} from '../../../api'
import { AuthContext } from '../../../context/auth'
import { ProductList } from '../../../componentsV1/ProductList'
import { ProductDetails } from '../../../componentsV1/ProductDetails';

export const AlexaFlourSecondary = () => {
    const navigate = useNavigate()
    const galleryUrl = `${process.env.REACT_APP_GALLERY_URL}150:150`
    const { setIsLoading, setNotification, isLoading, setCartData, tempDisable, setTempDisable, width } = useContext(AuthContext)
    const [productSelection, setProductSelection] = useState({
        host: '',
        species_reactivity: {
            label: '',
            value: ''
        },
        full_length: {
            label: '',
            value: ''
        },
        dyeBtns: ''
    })
    const [openMethodologyModal, setOpenMethodologyModal] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [modalName, setModalName] = useState(null)
    const [currentPage, setCurrentPage] = useState(0);
    const [dyeBtns, setDyeBtns] = useState('')
    const [allProducts, setAllProducts] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const [showFilter, setShowFilter] = useState(false)
    const limit = 5

    useEffect(() => {
        setIsLoading(true);
        getProductApi(
            'SA',
            productSelection?.dyeBtns,
            limit,
            currentPage * limit,
            productSelection?.host,
            productSelection?.species_reactivity?.value,
            productSelection?.full_length?.value
        ).then((res) => {
            if (res?.data?.products) {
                const newProducts = res.data.products;
                setAllProducts((prev) => {
                    if (currentPage === 0) {
                        return newProducts;
                    }
                    return [...prev, ...newProducts];
                });
                if (newProducts.length < limit) {
                    setHasMore(false);
                }
            } else {
                setHasMore(false);
            }

            setIsLoading(false);
        });

    }, [currentPage, productSelection]);

    const fetchMoreData = () => {
        if (!isLoading && hasMore) {
            setCurrentPage((prev) => prev + 1);
        }
    };

    useEffect(() => {
        setCurrentPage(0);
        setAllProducts([]);
        setHasMore(true);
    }, [productSelection]);

    const renderFilters = [
        <Dropdown
            optionType='array'
            options={['Donkey', 'Goat', 'Rabbit']}
            value={productSelection.host}
            label={'Host'}
            onChange={(e) => {
                if (productSelection.host !== e) {
                    setProductSelection({
                        ...productSelection,
                        host: e
                    })
                    setCurrentPage(0)
                } else {
                    setProductSelection({
                        ...productSelection,
                        host: ''
                    })
                    setCurrentPage(0)
                }
            }}
            className={css.dropdown}
        />,
        <Dropdown
            optionType='object'
            options={[
                {
                    value: 'Anti-Human',
                    label: 'Human'
                },
                {
                    value: 'Anti-Mouse',
                    label: 'Mouse'
                },
                {
                    value: 'Anti-Rabbit',
                    label: 'Rabbit'
                },
                {
                    value: 'Anti-Rat',
                    label: 'Rat'
                }
            ]}
            value={productSelection.species_reactivity.label}
            label={'Species'}
            onChange={(e) => {
                if (productSelection.species_reactivity.label !== e.label) {
                    setProductSelection({
                        ...productSelection,
                        species_reactivity: e
                    })
                    setCurrentPage(0)
                } else {
                    setProductSelection({
                        ...productSelection,
                        species_reactivity: {
                            label: '',
                            value: ''
                        }
                    })
                    setCurrentPage(0)
                }
            }}
            className={css.dropdown}
        />,
        <Dropdown
            optionType='object'
            options={[
                {
                    label: 'Whole IgG',
                    value: 'IgG'
                },
                {
                    label: 'F(ab’)₂',
                    value: 'F(ab’)₂'
                }
            ]}
            value={productSelection.full_length?.label}
            label={'Length'}
            onChange={(e) => {
                if (productSelection.full_length?.label !== e.label) {
                    setProductSelection({
                        ...productSelection,
                        full_length: e
                    })
                    setCurrentPage(0)
                } else {
                    setProductSelection({
                        ...productSelection,
                        full_length: {
                            label: '',
                            value: ''
                        }
                    })
                    setCurrentPage(0)
                }
            }}
            className={css.dropdown}
        />,
        <Dropdown
            optionType='array'
            options={[405, 488, 532, 555, 594, 647, 680, 750, 790]}
            value={productSelection.dyeBtns}
            label={'Dye'}
            onChange={(e) => {
                if (productSelection.host !== e) {
                    setProductSelection({
                        ...productSelection,
                        dyeBtns: e
                    })
                    setCurrentPage(0)
                } else {
                    setProductSelection({
                        ...productSelection,
                        dyeBtns: ''
                    })
                    setCurrentPage(0)
                }
            }}
            className={css.dropdown}
        />,
        <button className={css.transparentBtn} onClick={() => {
            setProductSelection({
                host: '',
                species_reactivity: {
                    label: '',
                    value: ''
                },
                full_length: {
                    label: '',
                    value: ''
                },
                dyeBtns: ''
            })
            setSelectedProduct(null)
            setCurrentPage(0)
        }}>
            Reset
        </button>
    ]

    return (
        <Layout>
            <div className={css.heroContainer}>
                <div className={css.heroContent}>
                    <img src={Logo} alt="logo" className={css.heroLogo} />
                    <div className={css.heroText}>
                        <h1>Identifyn® SRM Alexa Fluor™ <br />
                            Secondary Fluorescence
                        </h1>
                        <div className={css.line} />
                        <p>Precision-tuned secondary antibodies engineered for spectral clarity, signal strength, and multiplex confidence.</p>
                    </div>
                    <div className={css.logoContainer}>
                        <div className={css.logo}>
                            <img src={Validation} alt='validation' />
                            <p>Engineered for controlled signal interpretation, rigorously validated, and seamlessly integrated across the Identifyn® platform</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${css.section} ${selectedProduct ? css.showProduct : css.hideProduct}`}>
                <div className={css.selectionContainer}>
                    <div className={css.graphContainer}>
                        <Graph data={productSelection?.dyeBtns} />
                    </div>
                    <div className={css.listContainer}>
                        <div className={css.filtersContainer}>
                            {renderFilters}
                        </div>
                        <div className={css.mobileFilters}>
                            <span className={css.label}>Secondary Products</span>
                            <button className={css.transparentBtn} onClick={() => setShowFilter(!showFilter)}>Filters</button>
                            {showFilter && (
                                <div className={css.showFilters}>
                                    <div className={css.filterHeader}>
                                        <h3>Filter</h3>
                                        <button className={css.navBtn} onClick={() => setShowFilter(false)}><i className='fas fa-times'></i></button>
                                    </div>
                                    <div className={css.filters}>
                                        {renderFilters}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className={css.divider} />
                        <ProductList products={allProducts} setSelectedProduct={setSelectedProduct} hasMore={hasMore} fetchMoreData={fetchMoreData} />
                    </div>
                </div>
                <div className={css.productContainer}>
                <ProductDetails selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} setModalName={setModalName} setOpenMethodologyModal={setOpenMethodologyModal} />
                </div>
            </div>
            {openMethodologyModal && <MethodologyModal setOpenMethodologyModal={setOpenMethodologyModal} selectedProduct={selectedProduct} modalName={modalName} setModalName={setModalName} />}
        </Layout>
    );
}
